import { useState, type FormEvent } from "react";
import { Button, Card, Input } from "@insights/ui";
import { api, authClient } from "../../../api";
import { PageHeader } from "../../../shared/components";
import { AppShell } from "../../../shared/layout";

export function ProfilePage() {
  const session = authClient.useSession();
  const [profileName, setProfileName] = useState(session.data?.user.name ?? "");

  async function saveProfile(event: FormEvent) {
    event.preventDefault();
    await api("/profile", {
      method: "PATCH",
      body: JSON.stringify({ name: profileName }),
    });
    await session.refetch();
  }

  return (
    <AppShell>
      <PageHeader eyebrow="Your account" title="Profile" />
      <div className="admin-grid">
        <Card className="form-card wide-card">
          <h2 className="section-card-title">Personal profile</h2>
          <p>
            This name is used by default when you join a new workspace. Names
            customized within existing workspaces remain unchanged.
          </p>
          <form className="profile-form" onSubmit={saveProfile}>
            <label className="profile-field">
              <span>Email</span>
              <Input
                type="email"
                value={session.data?.user.email ?? ""}
                readOnly
              />
            </label>
            <label className="profile-field">
              <span>Name</span>
              <Input
                value={profileName}
                onChange={(event) => setProfileName(event.target.value)}
                maxLength={100}
                required
              />
            </label>
            <Button>Save profile</Button>
          </form>
        </Card>
      </div>
    </AppShell>
  );
}
